'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_51d8f436 = {"arrow":"Pagination_module_arrow__b8d27768"};
require("../../../assets/cjs/components/Table/src/Pagination~Bx-nfOj4.css");

exports.default = modules_51d8f436;
//# sourceMappingURL=Pagination.module.less.js.map
